<script>
    import JobBullets from './components/JobBullets.vue'
    import WakaTimes from "./components/WakaTimes";
    import WakaDev from "./components/WakaDev";
    import SkillSummary from "./components/SkillSummary";
    import Confessions from "./components/Confessions";

    export default {
        name: 'fredsApp',
        components: {JobBullets, WakaTimes, WakaDev, SkillSummary}
    }
</script>

<template>
    <main>

        <article id="fmd-app">
            <section class="eyebrow">
                <p>I'm a Full Stack Web Application Developer with Specialization in Marketing Cloud-based Technologies, User Experience, User Interaction and Web Accessibility</p>
            </section>

            <section>
                <h3>Basic Information</h3>
                <div class="basic-information">
                    <div class="left">
                        <p>Currently developing several projects for LMIG using React on the front-end (Hooks) interfacing with a Spring Boot backend & MySQL, which is housed in PCF wrappers of AWS services in several US and EU availability zones. Fun stuff!!</p>
                        <p>5+ years of software development expertise interfacing with business stakeholders, designers and
                            agile development teams to take cutting-edge web based applications to market. Designing, coding
                            and
                            implementation of backend functionality for transformational products to create business value
                            for
                            clients.</p>
                        <p>Innovative Problem Solver with aptitude for creating detailed graphical renderings to help end
                            users
                            visualize solution strategies. Rich background adapting quickly to new things and learning new
                            technologies. Demonstrated ability to work within ambiguity and pursuing effective solutions
                            with
                            crystal clear communication and engaged collaboration.</p>
                        <p>Business-Centric Communicator able to ascertain and articulate root causes, simplify complex
                            business
                            and technical issues. Adept at working in dynamic environments that require collaboration with
                            stakeholders to pinpoint business needs and create detailed specifications.</p>
                    </div>
                    <div class="right">
                        <p><strong>TECHNOLOGIES:</strong><br>
                            JavaScript, Java, Vue, KnockoutJS, jQuery, CSS/LESS/SASS, HTML5, Node, Python, Adobe Experience Manager, Java Content Repository (JCR), Adobe Digital Asset Manager, Adobe Search & Promote, Adobe Dynamic Media, Ajax, Photoshop, Illustrator</p>
                        <p><strong>DEVELOPMENT PROCESSES:</strong><br>
                            SDLC, Agile Scrum, Sprints, Jira, Story-Boarding, QA, Test Design/Execution, Prototyping,
                            Release
                            Management, Requirements Analysis, Specification Development, UX/UI, GDPR/Accessibility
                            Compliance
                        </p>
                    </div>
                </div>
            </section>

            <section>
                <job-bullets></job-bullets>
            </section>

            <section>
                <skill-summary></skill-summary>
            </section>

<!--            <section>-->
<!--                <waka-dev></waka-dev>-->
<!--            </section>-->

<!--            <section>-->
<!--                <waka-times></waka-times>-->
<!--            </section>-->

            <section class="prototypes">
                <h3>Prototypes</h3>
                <div>
                    <a href="/posts/aws-time-application/index.html">AWS Lambda Time/Activity Application (In-progress)</a>
                </div>
                <div>
                    <a href="/posts/ko/spa-test/index.html">Knockout Viewmodel Test</a>
                </div>
                <div>
                    <a href="/posts/ko/spa-modal-pub-sub/index.html">Knockout Viewmodel Pub/Sub Test</a>
                </div>
            </section>

        </article>
    </main>
</template>

<style lang="scss">
    @import "scss/base.scss";
</style>
